/**
 * G comparison — 单 section 多 table tabs。
 * Heading / table block 渲染 tab 与 pane，Row block 归属最近的 heading。
 */
(function () {
  if (!window.customElements.get('g-comparison')) {
    window.customElements.define('g-comparison', class GComparison extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.abortController = new AbortController();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panes = Array.from(this.querySelectorAll('[data-comparison-pane]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab), { signal: this.abortController.signal });
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab), { signal: this.abortController.signal });
        });

        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const selectedBlock = event.target.closest('[data-shopify-editor-block]');
            if (!selectedBlock) return;

            let pane = event.target.closest('[data-comparison-pane]');
            if (!pane) {
              const tab = event.target.closest('[role="tab"]');
              if (tab) pane = this.querySelector(`[data-comparison-pane][data-tab-index="${tab.dataset.tabIndex}"]`);
            }

            const targetTab = pane ? this.tabs.find((tab) => tab.dataset.tabIndex === pane.dataset.tabIndex) : event.target.closest('[role="tab"]');
            if (targetTab) this.select(targetTab, false);
          }, { signal: this.abortController.signal });
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      select(selectedTab, focus = true) {
        if (!selectedTab) return;
        const selectedIndex = selectedTab.dataset.tabIndex;

        this.tabs.forEach((tab) => {
          const isSelected = tab.dataset.tabIndex === selectedIndex;
          tab.dataset.active = isSelected ? 'true' : 'false';
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panes.forEach((pane) => {
          const isVisible = pane.dataset.tabIndex === selectedIndex;
          pane.dataset.visible = isVisible ? 'true' : 'false';
          pane.hidden = !isVisible;
        });

        if (focus) selectedTab.focus({ preventScroll: true });
      }

      handleKeydown(event, currentTab) {
        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        this.select(this.tabs[nextIndex]);
      }
    });
  }
})();
